<script setup>
import moment from "moment";
</script>
<template>
  <DefaultLayout>
    <v-row class="mx-5 mt-5">
      <v-col cols="12">
        <div
          class="bg-red-ss rounded-top-10 w-100 border border-1 pt-2"
          style="min-height: 5vh"
        >
          <div style="color: #28293d" class="flex items-center mb-2">
            <button @click="$router.back()" class="btn">
              <font-awesome-icon
                icon="fa-solid fa-arrow-left"
                style="color: #28293d"
              />
            </button>
            Dokumen Pra-Presentasi PJP Baru
          </div>
          <div
            class="bg-white rounded-top-10 w-100 border border-1 shadow-sm p-2"
            style="min-height: 60vh"
          >
            <div class="container-fluid">
              <!-- <img :src="showttd" style="height:3rem" /> -->
              <h4
                style="
                  color: #dd3737;
                  font-family: 'Inter-Medium';
                  font-style: normal;
                  font-weight: bold;
                  font-size: 2.5rem;
                "
                class="pt-5"
              >
                Dokumen Persyaratan Pengajuan PJO
              </h4>
              <p class="text-secondary">{{ kontraktorName }}</p>
              <div class="row mb-4"></div>
              <div class="row">
                <div class="row mb-2">
                  <div class="col-md-2">&nbsp;</div>
                  <div class="col-md-10">Dokumen</div>
                </div>

                <v-row class="mb-4" v-for="ld in listDokumen" :key="ld.id">
                  <v-col cols="1">
                    <div class="flex justify-center items-center">
                      <span class="text-3xl text-red-700 ml-8">
                        {{ ld.id }}
                      </span>
                    </div>
                  </v-col>
                  <v-col cols="11">
                    <div class="row border rounded p-2 bg-white">
                      <div
                        class="col-md-1 d-flex justify-content-center align-items-center"
                      >
                        <!-- <span> -->
                        <font-awesome-icon
                          icon="fa-solid fa-circle-exclamation text-secondary fa-xl"
                          style="font-size: 2rem; color: #ffcc00"
                          class="text-center"
                          v-if="
                            ld.id < 6 &&
                            ld.statusFile === false &&
                            ld.reason != ''
                          "
                        />
                        <font-awesome-icon
                          icon="fa-solid fa-circle-exclamation text-secondary fa-xl"
                          style="font-size: 2rem; color: #ffcc00"
                          class="text-center"
                          v-else-if="
                            ld.id == 6 &&
                            ld.statusFile === false &&
                            reasondata.reasonDocument != null &&
                            reasondata.reasonDocument != ''
                          "
                        />
                        <font-awesome-icon
                          icon="fa-solid fa-circle-exclamation text-secondary fa-xl"
                          style="font-size: 2rem; color: #ffcc00"
                          class="text-center"
                          v-else-if="
                            ld.id == 7 &&
                            ld.statusFile === false &&
                            reasondata.reasonImkp != null &&
                            reasondata.reasonImkp != ''
                          "
                        />
                        <font-awesome-icon
                          icon="fa-solid fa-square-check text-secondary fa-xl"
                          style="font-size: 2rem; color: #929292"
                          class="text-center"
                          v-else-if="ld.statusFile === false && ld.reason == ''"
                        />
                        <font-awesome-icon
                          icon="fa-solid fa-square-check text-secondary fa-xl"
                          style="font-size: 2rem; color: #0c8953"
                          class="text-center"
                          v-else-if="ld.statusFile === true"
                        />

                        <!-- </span> -->
                      </div>
                      <div class="col-md-7 d-flex align-items-center">
                        <span class="align-middle">
                          {{ ld.label }}
                          <!-- <i v-if="ld.id==7" class="text-danger fs-8">(Tidak wajib diisi)</i> -->
                        </span>
                      </div>
                      <div
                        class="col-md-2 d-flex justify-content-center align-items-center"
                      >
                        <button
                          v-if="
                            ld.id < 6 &&
                            ld.statusFile === true &&
                            (status == 1 || status == -3) &&
                            userData.role.length > 0 &&
                            userData.role.includes('ADMIN')
                          "
                          data-bs-toggle="modal"
                          :data-bs-target="'#exampleModal' + ld.id"
                          class="btn btn-outline-danger fs-9"
                        >
                          Dokumen Belum Lengkap?
                        </button>
                        <button
                          v-else-if="
                            ld.id == 6 &&
                            ld.statusFile === true &&
                            (status == 1 || status == -3) &&
                            (reasondata.reasonDocument == null ||
                              reasondata.reasonDocument == '') &&
                            userData.role.length > 0 &&
                            userData.role.includes('ADMIN')
                          "
                          data-bs-toggle="modal"
                          :data-bs-target="'#exampleModal' + ld.id"
                          class="btn btn-outline-danger fs-9"
                        >
                          Dokumen Belum Lengkap?
                        </button>
                        <button
                          v-else-if="
                            ld.id == 7 &&
                            ld.statusFile === true &&
                            (status == 1 || status == -3) &&
                            (reasondata.reasonImkp == null ||
                              reasondata.reasonImkp == '') &&
                            userData.role.length > 0
                          "
                          type="button"
                          data-bs-toggle="modal"
                          :data-bs-target="'#exampleModal' + ld.id"
                          class="btn btn-outline-danger fs-9"
                        >
                          Dokumen Belum Lengkap?
                        </button>
                        <a
                          v-if="
                            ld.id < 6 &&
                            ld.statusFile === false &&
                            ld.reason != ''
                          "
                          @click="lihatCatatan(ld.reason)"
                          style="
                            text-decoration: none;
                            color: #dd3737;
                            font-family: 'Inter-Bold';
                          "
                          class="fs-7 pointer"
                          data-bs-toggle="modal"
                          data-bs-target="#modalCatatan"
                          ><font-awesome-icon icon="fa-solid fa-comment-dots" />
                          Lihat Catatan</a
                        >
                        <a
                          v-else-if="
                            ld.id == 6 &&
                            ld.statusFile === false &&
                            reasondata.reasonDocument != null &&
                            reasondata.reasonDocument != ''
                          "
                          @click="lihatCatatan(reasondata.reasonDocument)"
                          style="
                            text-decoration: none;
                            color: #dd3737;
                            font-family: 'Inter-Bold';
                          "
                          class="fs-7 pointer"
                          data-bs-toggle="modal"
                          data-bs-target="#modalCatatan"
                          ><font-awesome-icon icon="fa-solid fa-comment-dots" />
                          Lihat Catatan</a
                        >
                        <a
                          v-else-if="
                            ld.id == 7 &&
                            ld.statusFile === false &&
                            reasondata.reasonImkp != null &&
                            reasondata.reasonImkp != ''
                          "
                          @click="lihatCatatan(reasondata.reasonImkp)"
                          style="
                            text-decoration: none;
                            color: #dd3737;
                            font-family: 'Inter-Bold';
                          "
                          class="fs-7 pointer"
                          data-bs-toggle="modal"
                          data-bs-target="#modalCatatan"
                          ><font-awesome-icon icon="fa-solid fa-comment-dots" />
                          Lihat Catatan</a
                        >
                      </div>
                      <div
                        class="col-md-2 d-flex justify-content-center align-items-center"
                      >
                        <button
                          type="button"
                          class="btn btn_eform rounded border w-100"
                          @click="toForm(ld.linkForm)"
                          v-if="
                            ld.statusFile === false &&
                            ld.type == 'form' &&
                            status == 0
                          "
                        >
                          Isi e-Form
                        </button>
                        <button
                          type="button"
                          class="btn btn_eform rounded border w-100"
                          @click="toForm(ld.linkForm)"
                          v-else-if="
                            ld.statusFile === false &&
                            ld.type == 'formUpload' &&
                            status == 0
                          "
                        >
                          Isi & Upload
                        </button>
                        <button
                          type="button"
                          class="btn btn_eform rounded border w-100"
                          v-else-if="ld.type == 'upload' && status == 0"
                          data-bs-toggle="modal"
                          data-bs-target="#exampleModal"
                        >
                          Upload
                        </button>
                        <button
                          type="button"
                          class="btn btn_eform rounded border w-100"
                          @click="toForm(ld.linkForm)"
                          v-if="
                            ld.statusFile === true &&
                            (ld.type == 'form' || ld.type == 'formUpload') &&
                            status == 0
                          "
                        >
                          Edit e-Form
                        </button>
                        <button
                          type="button"
                          class="btn btn_eform rounded border w-100"
                          @click="toForm(ld.linkForm, ld.idForm)"
                          v-if="
                            ld.statusFile === true &&
                            (ld.type == 'form' || ld.type == 'formUpload') &&
                            (status == 1 ||
                              status == 2 ||
                              status == -3 ||
                              status == 5 ||
                              status ||
                              6)
                          "
                        >
                          Lihat e-Form
                        </button>
                        <button
                          type="button"
                          class="btn btn_eform rounded border w-100"
                          @click="toForm(ld.linkForm, ld.idForm)"
                          v-if="
                            ld.statusFile === false &&
                            ld.reason != '' &&
                            (ld.type == 'form' || ld.type == 'formUpload') &&
                            (status == 1 ||
                              status == 2 ||
                              status == -3 ||
                              status == 5 ||
                              status ||
                              6)
                          "
                        >
                          Lihat e-Form
                        </button>
                      </div>
                    </div>
                    <div v-if="ld.attachment === undefined">
                      <!-- form 1 & 2 -->
                      <div
                        class="row border rounded p-2 bg-white"
                        v-if="ld.id == 1 || ld.id == 2"
                      >
                        <div class="col-md-10"></div>
                        <div
                          class="col-md-2 d-flex justify-content-center align-items-center"
                        >
                          <a
                            style="
                              font-family: 'Inter-Bold';
                              font-size: 1.2rem;
                              color: #dd3737;
                              cursor: pointer;
                            "
                            @click="
                              redirectToLink(
                                `/printDokumenForm${ld.id}/`,
                                ld.idForm
                              )
                            "
                            class="text-danger text-decoration-none pointer"
                          >
                            <font-awesome-icon
                              icon="fa-solid fa-download"
                              style=""
                            />
                          </a>
                        </div>
                      </div>
                      <div
                        v-for="(a, idx) in ld.attachment"
                        :key="idx"
                        class="row border rounded p-2 bg-white"
                      >
                        <div
                          class="col-md-1 d-flex justify-content-center align-items-center"
                        >
                          &nbsp;
                        </div>
                        <div class="col-md-9 d-flex align-items-center">
                          <span class="align-middle">{{ a }}</span>
                        </div>
                        <div
                          class="col-md-2 d-flex justify-content-center align-items-center"
                        >
                          <a
                            @click="
                              removeFile(ld.id, ld.realFileName, ld.idForm)
                            "
                            class="text-danger text-decoration-none pointer"
                            >Remove</a
                          >
                        </div>
                      </div>
                    </div>
                    <!-- if file more than one -->
                    <div v-else>
                      <div
                        class="row border rounded p-2 bg-white"
                        v-for="(a, idx) in ld.attachment"
                        :key="idx"
                      >
                        <div
                          class="col-md-1 d-flex justify-content-center align-items-center"
                        >
                          &nbsp;
                        </div>
                        <div
                          class="col-md-9 d-flex align-items-start flex-column"
                        >
                          <span class="align-middle">{{ a }}</span>
                          <div class="mt-2" v-if="ld.id == 7">
                            <!-- q1 -->
                            <div
                              v-if="
                                Array.isArray(ld.assets[idx].q1) &&
                                ld.assets[idx].q1.length > 0
                              "
                            >
                              <span> File Kontrak : </span>
                              <ul>
                                <!-- If it's an array, print loop of array items as list items -->
                                <li
                                  v-for="(file, index) in ld.assets[idx].q1"
                                  :key="index"
                                >
                                  <a
                                    class="text-danger pointer"
                                    @click="viewFile(file)"
                                  >
                                    {{ "File Kontrak " + (index + 1) }}
                                  </a>
                                </li>
                              </ul>
                            </div>

                            <!-- q2 -->
                            <div
                              v-if="
                                Array.isArray(ld.assets[idx].q2) &&
                                ld.assets[idx].q2.length > 0
                              "
                            >
                              <span> File Dokumen Legal : </span>
                              <ul>
                                <!-- If it's an array, print loop of array items as list items -->
                                <li
                                  v-for="(file, index) in ld.assets[idx].q2"
                                  :key="index"
                                >
                                  <a
                                    class="text-danger pointer"
                                    @click="viewFile(file)"
                                  >
                                    {{ "File Dokumen Legal " + (index + 1) }}
                                  </a>
                                </li>
                              </ul>
                            </div>

                            <!-- q3 -->
                            <div
                              v-if="
                                Array.isArray(ld.assets[idx].q3) &&
                                ld.assets[idx].q3.length > 0
                              "
                            >
                              <span> File Metode Kerja : </span>
                              <ul>
                                <!-- If it's an array, print loop of array items as list items -->
                                <li
                                  v-for="(file, index) in ld.assets[idx].q3"
                                  :key="index"
                                >
                                  <a
                                    class="text-danger pointer"
                                    @click="viewFile(file)"
                                  >
                                    {{ "File Metode Kerja " + (index + 1) }}
                                  </a>
                                </li>
                              </ul>
                            </div>

                            <!-- q4 -->
                            <div
                              v-if="
                                Array.isArray(ld.assets[idx].q4) &&
                                ld.assets[idx].q4.length > 0
                              "
                            >
                              <span>
                                File Identifikasi Bahaya dan Pengendalian Resiko
                                :
                              </span>
                              <ul>
                                <!-- If it's an array, print loop of array items as list items -->
                                <li
                                  v-for="(file, index) in ld.assets[idx].q4"
                                  :key="index"
                                >
                                  <a
                                    class="text-danger pointer"
                                    @click="viewFile(file)"
                                  >
                                    {{
                                      "Identifikasi Bahaya dan Pengendalian Resiko " +
                                      (index + 1)
                                    }}
                                  </a>
                                </li>
                              </ul>
                            </div>

                            <!-- q5 -->
                            <div
                              v-if="
                                Array.isArray(ld.assets[idx].q5) &&
                                ld.assets[idx].q5.length > 0
                              "
                            >
                              <span> File Daftar pekerja : </span>
                              <ul>
                                <!-- If it's an array, print loop of array items as list items -->
                                <li
                                  v-for="(file, index) in ld.assets[idx].q5"
                                  :key="index"
                                >
                                  <a
                                    class="text-danger pointer"
                                    @click="viewFile(file)"
                                  >
                                    {{ "File Daftar pekerja " + (index + 1) }}
                                  </a>
                                </li>
                              </ul>
                            </div>

                            <!-- q6 -->
                            <div
                              v-if="
                                Array.isArray(ld.assets[idx].q6) &&
                                ld.assets[idx].q6.length > 0
                              "
                            >
                              <span> File Daftar sarana prasarana : </span>
                              <ul>
                                <!-- If it's an array, print loop of array items as list items -->
                                <li
                                  v-for="(file, index) in ld.assets[idx].q6"
                                  :key="index"
                                >
                                  <a
                                    class="text-danger pointer"
                                    @click="viewFile(file)"
                                  >
                                    {{
                                      "File Daftar sarana prasarana " +
                                      (index + 1)
                                    }}
                                  </a>
                                </li>
                              </ul>
                            </div>

                            <!-- q7 -->
                            <div
                              v-if="
                                Array.isArray(ld.assets[idx].q7) &&
                                ld.assets[idx].q7.length > 0
                              "
                            >
                              <span> File Standar Operasional Prosedur : </span>
                              <ul>
                                <!-- If it's an array, print loop of array items as list items -->
                                <li
                                  v-for="(file, index) in ld.assets[idx].q7"
                                  :key="index"
                                >
                                  <a
                                    class="text-danger pointer"
                                    @click="viewFile(file)"
                                  >
                                    {{
                                      "File Standar Operasional Prosedur " +
                                      (index + 1)
                                    }}
                                  </a>
                                </li>
                              </ul>
                            </div>

                            <!-- q8 -->
                            <div
                              v-if="
                                Array.isArray(ld.assets[idx].q8) &&
                                ld.assets[idx].q8.length > 0
                              "
                            >
                              <span> File HSE Plan : </span>
                              <ul>
                                <!-- If it's an array, print loop of array items as list items -->
                                <li
                                  v-for="(file, index) in ld.assets[idx].q8"
                                  :key="index"
                                >
                                  <a
                                    class="text-danger pointer"
                                    @click="viewFile(file)"
                                  >
                                    {{ "File HSE Plan " + (index + 1) }}
                                  </a>
                                </li>
                              </ul>
                            </div>

                            <!-- q9 -->
                            <div
                              v-if="
                                Array.isArray(ld.assets[idx].q9) &&
                                ld.assets[idx].q9.length > 0
                              "
                            >
                              <span> File Manajemen Perubahan (MOC) : </span>
                              <ul>
                                <!-- If it's an array, print loop of array items as list items -->
                                <li
                                  v-for="(file, index) in ld.assets[idx].q9"
                                  :key="index"
                                >
                                  <a
                                    class="text-danger pointer"
                                    @click="viewFile(file)"
                                  >
                                    {{
                                      "File Manajemen Perubahan (MOC) " +
                                      (index + 1)
                                    }}
                                  </a>
                                </li>
                              </ul>
                            </div>

                            <!-- q10 -->
                            <div
                              v-if="
                                Array.isArray(ld.assets[idx].q10) &&
                                ld.assets[idx].q10.length > 0
                              "
                            >
                              <span> File Water Management Plan : </span>
                              <ul>
                                <!-- If it's an array, print loop of array items as list items -->
                                <li
                                  v-for="(file, index) in ld.assets[idx].q10"
                                  :key="index"
                                >
                                  <a
                                    class="text-danger pointer"
                                    @click="viewFile(file)"
                                  >
                                    {{
                                      "File Water Management Plan " +
                                      (index + 1)
                                    }}
                                  </a>
                                </li>
                              </ul>
                            </div>

                            <!-- q11 -->
                            <div
                              v-if="
                                Array.isArray(ld.assets[idx].q11) &&
                                ld.assets[idx].q11.length > 0
                              "
                            >
                              <span> File Hydrocarbon Management Plan : </span>
                              <ul>
                                <!-- If it's an array, print loop of array items as list items -->
                                <li
                                  v-for="(file, index) in ld.assets[idx].q11"
                                  :key="index"
                                >
                                  <a
                                    class="text-danger pointer"
                                    @click="viewFile(file)"
                                  >
                                    {{
                                      "File Hydrocarbon Management Plan " +
                                      (index + 1)
                                    }}
                                  </a>
                                </li>
                              </ul>
                            </div>

                            <!-- q12 -->
                            <div
                              v-if="
                                Array.isArray(ld.assets[idx].q12) &&
                                ld.assets[idx].q12.length > 0
                              "
                            >
                              <span> File Emergency Response Plan : </span>
                              <ul>
                                <!-- If it's an array, print loop of array items as list items -->
                                <li
                                  v-for="(file, index) in ld.assets[idx].q12"
                                  :key="index"
                                >
                                  <a
                                    class="text-danger pointer"
                                    @click="viewFile(file)"
                                  >
                                    {{
                                      "File Emergency Response Plan " +
                                      (index + 1)
                                    }}
                                  </a>
                                </li>
                              </ul>
                            </div>

                            <!-- q13 -->
                            <div
                              v-if="
                                Array.isArray(ld.assets[idx].q13) &&
                                ld.assets[idx].q13.length > 0
                              "
                            >
                              <span> File Struktur Organisasi Proyek : </span>
                              <ul>
                                <!-- If it's an array, print loop of array items as list items -->
                                <li
                                  v-for="(file, index) in ld.assets[idx].q13"
                                  :key="index"
                                >
                                  <a
                                    class="text-danger pointer"
                                    @click="viewFile(file)"
                                  >
                                    {{
                                      "File Struktur Organisasi Proyek " +
                                      (index + 1)
                                    }}
                                  </a>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                        <!-- form non 6 & 7 -->
                        <div
                          class="col-md-2 d-flex justify-content-center align-items-center"
                          v-if="
                            status == 0 &&
                            ld.realFileName !== null &&
                            ld.realFileName !== '' &&
                            ld.id != 7 &&
                            ld.id != 6
                          "
                        >
                          <a
                            @click="
                              removeFile(ld.id, ld.realFileName, ld.idForm)
                            "
                            class="text-danger text-decoration-none pointer"
                            >Remove</a
                          >
                        </div>
                        <div
                          class="col-md-2 d-flex justify-content-center align-items-center"
                          v-if="
                            (status == 1 ||
                              status == 2 ||
                              status == 3 ||
                              status == -3 ||
                              status == 5 ||
                              status == 6 ||
                              status == 7) &&
                            ld.realFileName !== null &&
                            ld.realFileName !== '' &&
                            ld.id != 7 &&
                            ld.id != 6
                          "
                        >
                          <!--                            <a @click="downloadFile(ld.realFileName, ld.label)"  class="text-danger text-decoration-none pointer">Download</a>-->
                          <a
                            style="
                              font-family: 'Inter-Bold';
                              font-size: 1.2rem;
                              color: #dd3737;
                              cursor: pointer;
                            "
                            @click="viewFile(ld.realFileName)"
                            class="text-danger text-decoration-none pointer"
                          >
                            <font-awesome-icon
                              icon="fa-solid fa-eye"
                              style=""
                            /> </a
                          >&nbsp;&nbsp;
                          <a
                            style="
                              font-family: 'Inter-Bold';
                              font-size: 1.2rem;
                              color: #dd3737;
                              cursor: pointer;
                            "
                            @click="downloadFile(ld.realFileName, ld.label)"
                            class="text-danger text-decoration-none pointer"
                          >
                            <font-awesome-icon
                              icon="fa-solid fa-download"
                              style=""
                            />
                          </a>
                        </div>
                        <!-- form 6 -->
                        <template v-if="ld.id == 6">
                          <template v-if="Array.isArray(ld.realFileName)">
                            <div
                              class="col-md-2 d-flex justify-content-center align-items-start"
                              v-if="
                                status == 0 && ld.realFileName[idx] !== null
                              "
                            >
                              <a
                                @click="
                                  removeFile(
                                    ld.id,
                                    ld.realFileName[idx],
                                    ld.idForm
                                  )
                                "
                                class="text-danger text-decoration-none pointer"
                                >Remove</a
                              >
                            </div>
                            <div
                              class="col-md-2 d-flex justify-content-center align-items-start"
                              v-if="
                                (status == 1 ||
                                  status == 2 ||
                                  status == 3 ||
                                  status == -3 ||
                                  status == 5 ||
                                  status == 6 ||
                                  status == 7 ||
                                  status == 8) &&
                                ld.realFileName[idx] !== null &&
                                ld.id == 6
                              "
                            >
                              <!--                            <a @click="downloadFile(ld.realFileName[idx], ld.label)"  class="text-danger text-decoration-none pointer">Download</a>-->
                              <a
                                style="
                                  font-family: 'Inter-Bold';
                                  font-size: 1.2rem;
                                  color: #dd3737;
                                  cursor: pointer;
                                "
                                @click="viewFile(ld.realFileName[idx])"
                                class="text-danger text-decoration-none pointer"
                              >
                                <font-awesome-icon
                                  icon="fa-solid fa-eye"
                                  style=""
                                /> </a
                              >&nbsp;&nbsp;
                              <a
                                style="
                                  font-family: 'Inter-Bold';
                                  font-size: 1.2rem;
                                  color: #dd3737;
                                  cursor: pointer;
                                "
                                @click="
                                  downloadFile(ld.realFileName[idx], ld.label)
                                "
                                class="text-danger text-decoration-none pointer"
                              >
                                <font-awesome-icon
                                  icon="fa-solid fa-download"
                                  style=""
                                />
                              </a>
                            </div>
                          </template>
                          <template v-else>
                            <div
                              class="col-md-2 d-flex justify-content-center align-items-start"
                              v-if="
                                status == 0 && ld.realFileName[idx] !== null
                              "
                            >
                              <a
                                @click="
                                  removeFile(ld.id, ld.realFileName, ld.idForm)
                                "
                                class="text-danger text-decoration-none pointer"
                                >Remove</a
                              >
                            </div>
                            <div
                              class="col-md-2 d-flex justify-content-center align-items-start"
                              v-if="
                                (status == 1 ||
                                  status == 2 ||
                                  status == 3 ||
                                  status == -3 ||
                                  status == 5 ||
                                  status == 6 ||
                                  status == 7) &&
                                ld.realFileName[idx] !== null &&
                                ld.id == 6
                              "
                            >
                              <!--                            <a @click="downloadFile(ld.realFileName[idx], ld.label)"  class="text-danger text-decoration-none pointer">Download</a>-->
                              <a
                                style="
                                  font-family: 'Inter-Bold';
                                  font-size: 1.2rem;
                                  color: #dd3737;
                                  cursor: pointer;
                                "
                                @click="viewFile(ld.realFileName)"
                                class="text-danger text-decoration-none pointer"
                              >
                                <font-awesome-icon
                                  icon="fa-solid fa-eye"
                                  style=""
                                /> </a
                              >&nbsp;&nbsp;
                              <a
                                style="
                                  font-family: 'Inter-Bold';
                                  font-size: 1.2rem;
                                  color: #dd3737;
                                  cursor: pointer;
                                "
                                @click="downloadFile(ld.realFileName, ld.label)"
                                class="text-danger text-decoration-none pointer"
                              >
                                <font-awesome-icon
                                  icon="fa-solid fa-download"
                                  style=""
                                />
                              </a>
                            </div>
                          </template>
                        </template>

                        <!-- form 7 -->
                        <div
                          class="col-md-2 d-flex justify-content-center align-items-start"
                          v-if="
                            status == 0 &&
                            ld.realFileName[idx] !== null &&
                            ld.id == 7
                          "
                        >
                          <a
                            @click="
                              removeFile(ld.id, ld.realFileName[idx], ld.idForm)
                            "
                            class="text-danger text-decoration-none pointer"
                            >Remove</a
                          >
                        </div>
                        <div
                          class="col-md-2 d-flex justify-content-center align-items-start"
                          v-if="
                            (status == 1 ||
                              status == 2 ||
                              status == 3 ||
                              status == -3 ||
                              status == 5 ||
                              status == 6 ||
                              status == 7) &&
                            ld.realFileName[idx] !== null &&
                            ld.id == 7
                          "
                        >
                          <!--                            <a @click="downloadFile(ld.realFileName[idx], ld.label)"  class="text-danger text-decoration-none pointer">Download</a>-->
                          <a
                            style="
                              font-family: 'Inter-Bold';
                              font-size: 1.2rem;
                              color: #dd3737;
                              cursor: pointer;
                            "
                            @click="viewFile(ld.realFileName[idx])"
                            class="text-danger text-decoration-none pointer"
                          >
                            <font-awesome-icon
                              icon="fa-solid fa-eye"
                              style=""
                            /> </a
                          >&nbsp;&nbsp;
                          <a
                            style="
                              font-family: 'Inter-Bold';
                              font-size: 1.2rem;
                              color: #dd3737;
                              cursor: pointer;
                            "
                            @click="
                              downloadFile(ld.realFileName[idx], ld.label)
                            "
                            class="text-danger text-decoration-none pointer"
                          >
                            <font-awesome-icon
                              icon="fa-solid fa-download"
                              style=""
                            />
                          </a>
                        </div>
                      </div>
                    </div>
                  </v-col>
                </v-row>
                <div v-if="type != 3">
                  <v-row class="mb-3" :hidden="status != 1">
                    <v-col cols="12" class="flex justify-end">
                      <button
                        type="button"
                        @click="submitSio()"
                        class="btn btn_cari w-30"
                        :hidden="!userData.role.includes('ADMIN')"
                      >
                        Approve Dokumen Pengajuan CoC
                      </button>
                    </v-col>
                  </v-row>
                </div>
              </div>
            </div>
          </div>
        </div>
      </v-col>
    </v-row>
  </DefaultLayout>
  <!-- Loading overlay -->
  <div v-if="isLoading" class="loading-overlay">
    <!-- You can customize the loading content here (e.g., a spinner) -->
    <div>
      <img
        src="../../assets/icons/Spinner-1s-200px.svg"
        style="height: 10rem"
        alt=""
      />
    </div>
  </div>
  <!-- modal filter -->
  <div
    class="modal fade"
    id="exampleModal1"
    tabindex="-1"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header flex justify-between">
          <h5 class="modal-title">Evaluasi Kelengkapan Dokumen</h5>
          <!-- <p>Silahkan Upload berkas anda</p> -->
          <div class="d-flex justify-content-end">
            <button
              ref="closeModalReject1"
              type="button"
              id="btnClose"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
        </div>
        <div class="modal-body" style="font-family: 'Inter-Regular'">
          <!-- <p>Modal body text goes here.</p> -->
          <p class="text-secondary fs-8">
            Masukkan Catatan Evaluasi Kelengkapan Dokumen
            <b>Surat Permohonan Pengesahan PJO</b> pada kolom dibawah ini
          </p>
          <div class="row">
            <div class="col-md-12">
              <div class="mb-1">
                <label for="file" class="form-label fs-8 fw-bold"
                  >Catatan</label
                >
              </div>
              <textarea
                class="form-control fs-8"
                id="exampleFormControlTextarea1"
                rows="7"
                v-model="reason_form1"
                placeholder="Masukkan catatan mengapa dokumen belum lengkap"
              ></textarea>
            </div>
          </div>
        </div>
        <div class="modal-footer border border-0 mt-1">
          <button
            class="btn btn_cari w-100 fs-8 fw-bold"
            @click="rejectSio(1, listDokumen[0].idForm)"
          >
            Simpan
          </button>
        </div>
      </div>
    </div>
  </div>
  <div
    class="modal fade"
    id="exampleModal2"
    tabindex="-1"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header flex justify-between">
          <h5 class="modal-title">Evaluasi Kelengkapan Dokumen</h5>
          <!-- <p>Silahkan Upload berkas anda</p> -->
          <div class="d-flex justify-content-end">
            <button
              ref="closeModalReject2"
              type="button"
              id="btnClose"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
        </div>
        <div class="modal-body" style="font-family: 'Inter-Regular'">
          <!-- <p>Modal body text goes here.</p> -->
          <p class="text-secondary fs-8">
            Masukkan Catatan Evaluasi Kelengkapan Dokumen
            <b>Daftar Riwayat Hidup dan Sertifikat</b> pada kolom dibawah ini
          </p>
          <div class="row">
            <div class="col-md-12">
              <div class="mb-1">
                <label for="file" class="form-label fs-8 fw-bold"
                  >Catatan</label
                >
              </div>
              <textarea
                class="form-control fs-8"
                id="exampleFormControlTextarea1"
                rows="7"
                v-model="reason_form2"
                placeholder="Masukkan catatan mengapa dokumen belum lengkap"
              ></textarea>
            </div>
          </div>
        </div>
        <div class="modal-footer border border-0 mt-1">
          <button
            class="btn btn_cari w-100 fs-8 fw-bold"
            @click="rejectSio(2, listDokumen[1].idForm)"
          >
            Simpan
          </button>
        </div>
      </div>
    </div>
  </div>
  <div
    class="modal fade"
    id="exampleModal3"
    tabindex="-1"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header flex justify-between">
          <h5 class="modal-title">Evaluasi Kelengkapan Dokumen</h5>
          <!-- <p>Silahkan Upload berkas anda</p> -->
          <div class="d-flex justify-content-end">
            <button
              ref="closeModalReject3"
              type="button"
              id="btnClose"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
        </div>
        <div class="modal-body" style="font-family: 'Inter-Regular'">
          <!-- <p>Modal body text goes here.</p> -->
          <p class="text-secondary fs-8">
            Masukkan Catatan Evaluasi Kelengkapan Dokumen
            <b>Surat Pernyataan Calon PJO</b> pada kolom dibawah ini
          </p>
          <div class="row">
            <div class="col-md-12">
              <div class="mb-1">
                <label for="file" class="form-label fs-8 fw-bold"
                  >Catatan</label
                >
              </div>
              <textarea
                class="form-control fs-8"
                id="exampleFormControlTextarea1"
                rows="7"
                v-model="reason_form3"
                placeholder="Masukkan catatan mengapa dokumen belum lengkap"
              ></textarea>
            </div>
          </div>
        </div>
        <div class="modal-footer border border-0 mt-1">
          <button
            class="btn btn_cari w-100 fs-8 fw-bold"
            @click="rejectSio(3, listDokumen[2].idForm)"
          >
            Simpan
          </button>
        </div>
      </div>
    </div>
  </div>
  <div
    class="modal fade"
    id="exampleModal4"
    tabindex="-1"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header flex justify-between">
          <h5 class="modal-title">Evaluasi Kelengkapan Dokumen</h5>
          <!-- <p>Silahkan Upload berkas anda</p> -->
          <div class="d-flex justify-content-end">
            <button
              ref="closeModalReject4"
              type="button"
              id="btnClose"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
        </div>
        <div class="modal-body" style="font-family: 'Inter-Regular'">
          <!-- <p>Modal body text goes here.</p> -->
          <p class="text-secondary fs-8">
            Masukkan Catatan Evaluasi Kelengkapan Dokumen
            <b>Surat Pernyataan Kebenaran Dokumen</b> pada kolom dibawah ini
          </p>
          <div class="row">
            <div class="col-md-12">
              <div class="mb-1">
                <label for="file" class="form-label fs-8 fw-bold"
                  >Catatan</label
                >
              </div>
              <textarea
                class="form-control fs-8"
                id="exampleFormControlTextarea1"
                rows="7"
                v-model="reason_form4"
                placeholder="Masukkan catatan mengapa dokumen belum lengkap"
              ></textarea>
            </div>
          </div>
        </div>
        <div class="modal-footer border border-0 mt-1">
          <button
            class="btn btn_cari w-100 fs-8 fw-bold"
            @click="rejectSio(4, listDokumen[3].idForm)"
          >
            Simpan
          </button>
        </div>
      </div>
    </div>
  </div>
  <div
    class="modal fade"
    id="exampleModal5"
    tabindex="-1"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header flex justify-between">
          <h5 class="modal-title">Evaluasi Kelengkapan Dokumen</h5>
          <!-- <p>Silahkan Upload berkas anda</p> -->
          <div class="d-flex justify-content-end">
            <button
              ref="closeModalReject5"
              type="button"
              id="btnClose"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
        </div>
        <div class="modal-body" style="font-family: 'Inter-Regular'">
          <!-- <p>Modal body text goes here.</p> -->
          <p class="text-secondary fs-8">
            Masukkan Catatan Evaluasi Kelengkapan Dokumen
            <b>Surat Pernyataan Dukungan Pimpinan Perusahaan</b> pada kolom
            dibawah ini
          </p>
          <div class="row">
            <div class="col-md-12">
              <div class="mb-1">
                <label for="file" class="form-label fs-8 fw-bold"
                  >Catatan</label
                >
              </div>
              <textarea
                class="form-control fs-8"
                id="exampleFormControlTextarea1"
                rows="7"
                v-model="reason_form5"
                placeholder="Masukkan catatan mengapa dokumen belum lengkap"
              ></textarea>
            </div>
          </div>
        </div>
        <div class="modal-footer border border-0 mt-1">
          <button
            class="btn btn_cari w-100 fs-8 fw-bold"
            @click="rejectSio(5, listDokumen[4].idForm)"
          >
            Simpan
          </button>
        </div>
      </div>
    </div>
  </div>
  <div
    class="modal fade"
    id="exampleModal6"
    tabindex="-1"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header justify-between flex">
          <h5 class="modal-title">Evaluasi Kelengkapan Dokumen</h5>
          <!-- <p>Silahkan Upload berkas anda</p> -->
          <div class="d-flex justify-content-end">
            <button
              ref="closeModalReject6"
              type="button"
              id="btnClose"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
        </div>
        <div class="modal-body" style="font-family: 'Inter-Regular'">
          <!-- <p>Modal body text goes here.</p> -->
          <p class="text-secondary fs-8">
            Masukkan Catatan Evaluasi Kelengkapan Dokumen
            <b>Materi Presentasi PJO</b> pada kolom dibawah ini
          </p>
          <div class="row">
            <div class="col-md-12">
              <div class="mb-1">
                <label for="file" class="form-label fs-8 fw-bold"
                  >Catatan</label
                >
              </div>
              <textarea
                class="form-control fs-8"
                id="exampleFormControlTextarea1"
                rows="7"
                v-model="reason_form6"
                placeholder="Masukkan catatan mengapa dokumen belum lengkap"
              ></textarea>
            </div>
          </div>
        </div>
        <div class="modal-footer border border-0 mt-1">
          <button
            class="btn btn_cari w-100 fs-8 fw-bold"
            @click="rejectSio(6, listDokumen[5].idForm)"
          >
            Simpan
          </button>
        </div>
      </div>
    </div>
  </div>
  <div
    class="modal fade"
    id="exampleModal7"
    tabindex="-1"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Evaluasi Kelengkapan Dokumen</h5>
          <!-- <p>Silahkan Upload berkas anda</p> -->
          <div class="d-flex justify-content-end">
            <button
              ref="closeModalReject7"
              type="button"
              id="btnClose"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
        </div>
        <div class="modal-body" style="font-family: 'Inter-Regular'">
          <!-- <p>Modal body text goes here.</p> -->
          <p class="text-secondary fs-8">
            Masukkan Catatan Evaluasi Kelengkapan Dokumen <b>Form IMKP</b> pada
            kolom dibawah ini
          </p>
          <div class="row">
            <div class="col-md-12">
              <div class="mb-1">
                <label for="file" class="form-label fs-8 fw-bold"
                  >Catatan</label
                >
              </div>
              <textarea
                class="form-control fs-8"
                id="exampleFormControlTextarea1"
                rows="7"
                v-model="reason_form7"
                placeholder="Masukkan catatan mengapa dokumen belum lengkap"
              ></textarea>
            </div>
          </div>
        </div>
        <div class="modal-footer border border-0 mt-1">
          <button
            class="btn btn_cari w-100 fs-8 fw-bold"
            @click="rejectSio(7, listDokumen[6].idForm)"
          >
            Simpan
          </button>
        </div>
      </div>
    </div>
  </div>
  <div
    class="modal fade"
    id="modalCatatan"
    tabindex="-1"
    aria-labelledby="modalCatatanLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Catatan</h5>
          <!-- <p>Silahkan Upload berkas anda</p> -->
          <div class="d-flex justify-content-end">
            <button
              ref="closeModalCatatan"
              type="button"
              id="btnClose"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
        </div>
        <div class="modal-body" style="font-family: 'Inter-Regular'">
          <!-- <p>Modal body text goes here.</p> -->
          <p class="fs-8" style="white-space: pre-line">
            {{ catatan }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import router from "../../router";
// import SidebarComponent from "@/components/SideBar.vue";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import GlobalDataMixin from "../../GlobalDataMixin";
import axios from "axios";
import Swal from "sweetalert2";

import {
  // APP_BACKEND_DEV,
  API_BASE_URL,
  // CMS_UPLOAD,
  CMS_GET_DETAILKONTRAKTOR,
  CMS_GET_SIOID,
  CMS_SET_SIOID,
  CMS_SIO_GET_DASHBOARD,
  CMS_SIO_SET_PERNYATAANPJO, //form 3
  CMS_SIO_SET_KEBENARAN_DOKUMEN, //form 4
  CMS_SIO_SET_DUKUNGAN_PIMPINAN, //form 5
  CMS_SIO_SET_IMKP, //form 7
  CMS_SIO_DEL_PRESENTASI,
  CMS_DOWNLOAD,
  CMS_VIEW_DOCUMENT, //del form 6
  CMS_SIO_SET_PJOPENGESAHAN,
  CMS_SIO_SET_PJODET,
  // CMS_SIO_SET_PERNYATAANPJO,
  // CMS_SIO_SET_KEBENARAN_DOKUMEN,
} from "../../constants.js";
import DefaultLayout from "@/layouts/DefaultLayout.vue";
import util from "@/assets/js/util";

const url_set_sioid = API_BASE_URL + CMS_SET_SIOID;
const url_get_sioid = API_BASE_URL + CMS_GET_SIOID;
const url_get_siodashboard = API_BASE_URL + CMS_SIO_GET_DASHBOARD;
const url_get_kontraktor = API_BASE_URL + CMS_GET_DETAILKONTRAKTOR;

const url_del_form3 = API_BASE_URL + CMS_SIO_SET_PERNYATAANPJO;
const url_del_form4 = API_BASE_URL + CMS_SIO_SET_KEBENARAN_DOKUMEN;
const url_del_form5 = API_BASE_URL + CMS_SIO_SET_DUKUNGAN_PIMPINAN;
const url_del_form6 = API_BASE_URL + CMS_SIO_DEL_PRESENTASI;
const url_del_form7 = API_BASE_URL + CMS_SIO_SET_IMKP;
const url_view_document = API_BASE_URL + CMS_VIEW_DOCUMENT;

const url_simpan_form1 = API_BASE_URL + CMS_SIO_SET_PJOPENGESAHAN;
const url_simpan_form2 = API_BASE_URL + CMS_SIO_SET_PJODET;
const url_simpan_form3 = API_BASE_URL + CMS_SIO_SET_PERNYATAANPJO;
const url_simpan_form4 = API_BASE_URL + CMS_SIO_SET_KEBENARAN_DOKUMEN;
const url_simpan_form5 = API_BASE_URL + CMS_SIO_SET_DUKUNGAN_PIMPINAN;
// const url_simpan_form6 = API_BASE_URL + CMS_SIO_SET_DUKUNGAN_PIMPINAN;
// const url_simpan_form7 = API_BASE_URL + CMS_SIO_SET_IMKP;

const url_download = API_BASE_URL + CMS_DOWNLOAD;
// const url_view = APP_BACKEND_DEV + CMS_VIEW_FILE; // dev purpose
// const url_view = API_BASE_URL + CMS_VIEW_FILE;

const url_detail_kontraktor = API_BASE_URL + CMS_GET_DETAILKONTRAKTOR;

export default {
  mixins: [GlobalDataMixin],
  name: "DokumenPersyaratanPengajuanPJO",
  components: {
    FontAwesomeIcon,
    DefaultLayout,
  },

  mounted() {
    // this.loadPage();
    // alert(this.$route.params.id);
    this.sioID = this.$route.params.id;
    this.getSioDashboard(this.sioID);
    this.kontraktorID = this.$route.params.kontraktorId;
    this.getSioID(this.kontraktorID);
    this.fetchDataKontraktor(this.kontraktorID);
    // this.isLoading = false;
  },
  data() {
    return {
      isLoading: true,
      catatan: "",
      listDokumen: [
        {
          id: 1,
          label: "Surat Permohonan Pengesahan PJO",
          statusFile: false,
          linkForm: "/form1View",
          type: "form",
          idForm: null,
          reason: "",
        },
        {
          id: 2,
          label: "Daftar Riwayat Hidup dan Sertifikat",
          statusFile: false,
          linkForm: "/form2View",
          type: "form",
          idForm: null,
          reason: "",
        },
        {
          id: 3,
          label: "Surat Pernyataan Calon PJO",
          statusFile: false,
          linkForm: "/form3View",
          type: "formUpload",
          attachment: [],
          realFileName: [],
          idForm: null,
          reason: "",
        },
        {
          id: 4,
          label: "Surat Pernyataan Kebenaran Dokumen",
          statusFile: false,
          linkForm: "/form4View",
          type: "formUpload",
          attachment: [],
          realFileName: [],
          idForm: null,
          reason: "",
        },
        {
          id: 5,
          label: "Surat Pernyataan Dukungan Pimpinan Perusahaan",
          statusFile: false,
          linkForm: "/form5View",
          type: "formUpload",
          attachment: [],
          realFileName: [],
          idForm: null,
          reason: "",
        },
        {
          id: 6,
          label: "Materi Presentasi PJO",
          statusFile: false,
          linkForm: "",
          type: "upload",
          attachment: [],
          realFileName: [],
          idForm: null,
          reason: "",
        },
        // {id:7,label:"Form IMKP",statusFile:false,linkForm:"/form7View",type:"formUpload",attachment:[], realFileName:[], idForm:null,assets:null,reason:'',},
      ],
      sioID: null,
      jumlahFileTerpenuhi: 0,
      jumlahFile: 6,
      kontraktorName: null,
      kontraktorID: null,
      detailsOpen: [],
      url_icon: "",
      status: 0,
      type: null,
      reason: "",
      reason_form1: "",
      reason_form2: "",
      reason_form3: "",
      reason_form4: "",
      reason_form5: "",
      reason_form6: "",
      reason_form7: "",
      reasondata: {
        reasonDocument: null,
        reasonDocumentDate: null,
        reasonImkp: null,
        reasonImkpDate: null,
      },
      // showttd:""
    };
  },
  methods: {
    toForm(link, id) {
      console.log("link = ", link);
      console.log("id = ", id);
      if (
        link == "/form3View" ||
        link == "/form4View" ||
        link == "/form5View"
      ) {
        console.log(link + "/" + id + "/" + this.kontraktorID);
        this.$router.push(link + "/" + id + "/" + this.kontraktorID);
      } else if (link == "/form7View") {
        this.$router.push(
          link + "/" + id + "/" + this.sioID + "/" + this.kontraktorID
        );
      } else {
        this.$router.push(link + "/" + id);
      }
    },
    onChangeArr(objArr, props, value, id) {
      const obj = objArr.find((x) => x.id === id);
      if (obj) {
        obj[props] = value;
      }
    },

    getSioID(id) {
      axios
        .get(url_get_sioid + id, {
          headers: {
            role: "isafe",
            Authorization: "Bearer " + this.userData.token,
            accept: "application/json",
          },
        })
        .then((response) => {
          console.log("response nya = ", response);
          // this.kontraktor = response.data.detailKontraktor
          // // set value form edit
          // this.formValues.namaKontraktor = this.kontraktor.namaKontraktor
          let dt = null;
          dt = response.data.data;
          if (dt != null) {
            this.sioID = dt.id;
            localStorage.setItem("sio_cms", JSON.stringify({ id: dt.id }));
            this.getSioDashboard(this.sioID);
            this.status = dt.status;
            if (dt.reasonData != null) {
              this.reasondata = JSON.parse(dt.reasonData);
            }
            this.type = dt.type;
          }

          this.isLoading = false;
        })
        .catch((error) => {
          this.isLoading = false;
          alert("Error Fetch Data getSioID : " + error.message);
          console.error("Error fetching data getSioID :", error.message);
        });
    },
    getSioDashboard(sio_id) {
      axios
        .get(url_get_siodashboard + sio_id, {
          headers: {
            role: "isafe",
            Authorization: "Bearer " + this.userData.token,
            accept: "application/json",
          },
        })
        .then((response) => {
          console.log("getSioDashboard => ", response);
          // this.kontraktor = response.data.detailKontraktor
          // // set value form edit
          // this.formValues.namaKontraktor = this.kontraktor.namaKontraktor
          let ret_dash = response.data.data;
          let jft = 0;
          // console.log(ret_dash.length)
          if (ret_dash.length > 0) {
            var formIMKP = [];
            var filesIMKP = [];
            var idIMKP = [];
            var assetsIMKP = [];
            for (let i = 0; i < ret_dash.length; i++) {
              this.onChangeArr(
                this.listDokumen,
                "statusFile",
                ret_dash[i].formStatus,
                ret_dash[i].idForm
              );
              this.onChangeArr(
                this.listDokumen,
                "reason",
                ret_dash[i].reason,
                ret_dash[i].idForm
              );

              if (
                ret_dash[i].attachment !== null &&
                ret_dash[i].attachment !== "" &&
                ret_dash[i].idForm != 7
              ) {
                console.log("att:", ret_dash[i].attachment);

                if (ret_dash[i].attachment.length > 1) {
                  // multi file
                  let fn = [];
                  let realfn = [];
                  for (let z = 0; z < ret_dash[i].attachment.length; z++) {
                    if (ret_dash[i].attachment[z] != null) {
                      realfn.push(ret_dash[i].attachment[z]);

                      let file = String(ret_dash[i].attachment[z]).split(".");
                      let extfile = file[1];
                      let index = this.listDokumen.filter(
                        (o) => o.id === ret_dash[i].idForm
                      )[0].id;
                      let filename =
                        this.listDokumen[index - 1].label +
                        " " +
                        (z + 1) +
                        "." +
                        extfile;
                      fn.push(filename);
                    }
                  }
                  this.onChangeArr(
                    this.listDokumen,
                    "attachment",
                    fn,
                    ret_dash[i].idForm
                  );
                  this.onChangeArr(
                    this.listDokumen,
                    "realFileName",
                    realfn,
                    ret_dash[i].idForm
                  );
                } else if (ret_dash[i].attachment.length == 1) {
                  // single file
                  if (ret_dash[i].attachment[0] !== "") {
                    let file = String(ret_dash[i].attachment).split(".");
                    let extfile = file[1];
                    let index = this.listDokumen.filter(
                      (o) => o.id === ret_dash[i].idForm
                    )[0].id;
                    let filename =
                      this.listDokumen[index - 1].label + "." + extfile;
                    this.onChangeArr(
                      this.listDokumen,
                      "attachment",
                      [filename],
                      ret_dash[i].idForm
                    );
                    this.onChangeArr(
                      this.listDokumen,
                      "realFileName",
                      ret_dash[i].attachment[0],
                      ret_dash[i].idForm
                    );
                  }
                }
              }

              if (ret_dash[i].idForm == 7) {
                let nm =
                  ret_dash[i].name == ""
                    ? "Tanpa Judul Proyek"
                    : ret_dash[i].name;
                formIMKP.push("IMKP : " + nm);
                filesIMKP.push(ret_dash[i].attachment[0]);
                idIMKP.push(ret_dash[i].id);
                let object_ass = {
                  q1: null,
                  q2: null,
                  q3: null,
                  q4: null,
                  q5: null,
                  q6: null,
                  q7: null,
                  q8: null,
                  q9: null,
                  q10: null,
                  q11: null,
                  q12: null,
                  q13: null,
                };
                if (ret_dash[i].assets != "" && ret_dash[i].assets != null) {
                  let ass = JSON.parse(ret_dash[i].assets);

                  for (let i = 1; i <= 13; i++) {
                    const questionKey = `q${i}`;
                    const cKey = `c_${questionKey}`;
                    const cArrayKey = `c_${questionKey}_array`;
                    const assetsKey = `assets_${cKey}`;

                    if (ass[cArrayKey]?.length > 0) {
                      object_ass[questionKey] = ass[cArrayKey];
                    } else if (ass[assetsKey]?.file?.length > 0) {
                      object_ass[questionKey] = ass[assetsKey].file;
                    }
                  }
                }

                assetsIMKP.push(object_ass);
                this.onChangeArr(
                  this.listDokumen,
                  "realFileName",
                  filesIMKP,
                  ret_dash[i].idForm
                );
                this.onChangeArr(
                  this.listDokumen,
                  "attachment",
                  formIMKP,
                  ret_dash[i].idForm
                );
                this.onChangeArr(
                  this.listDokumen,
                  "ids",
                  idIMKP,
                  ret_dash[i].idForm
                );
                this.onChangeArr(
                  this.listDokumen,
                  "assets",
                  assetsIMKP,
                  ret_dash[i].idForm
                );
                console.log(this.listDokumen);
              }

              // set value id form
              if (ret_dash[i].id != null) {
                // let index = this.listDokumen.filter(o => o.id===ret_dash[i].idForm)[0].id;
                this.onChangeArr(
                  this.listDokumen,
                  "idForm",
                  ret_dash[i].id,
                  ret_dash[i].idForm
                );
              }

              if (ret_dash[i].formStatus == true) {
                jft++;
              }
            }

            this.jumlahFileTerpenuhi = jft;
          }
          this.isLoading = false;
        })
        .catch((error) => {
          this.isLoading = false;
          alert("Error Fetch Data getSioDashboard : " + error.message);
          console.error("Error fetching data getSioDashboard :", error.message);
        });
    },

    getKontraktor(id) {
      axios
        .get(url_get_kontraktor + id, {
          headers: { accept: "application/json" },
        })
        .then((response) => {
          console.log(response);
          // this.kontraktor = response.data.detailKontraktor
          // set value form edit
          // this.url_icon = API_BASE_URL+CMS_VIEW_IMAGE+response.data.detailKontraktor.image;
          if (
            response.data.detailKontraktor.image != null ||
            response.data.detailKontraktor.image != ""
          ) {
            localStorage.setItem(
              "icon_kontraktor_cms",
              JSON.stringify({ icon: response.data.detailKontraktor.image })
            );
          }
        })
        .catch((error) => {
          this.isLoading = false;
          alert("Error Fetch Data Detail Kontraktor : " + error.message);
          console.error("Error fetching data:", error.message);
        });
    },
    alertSuksesSioID() {
      Swal.fire({
        title: "Create CoC ID Sukses",
        text: "CoC ID berhasil ditambahkan untuk Kontraktor Anda",
        icon: "success",
        showConfirmButton: false,
        timer: 2000,
        showClass: {
          popup: "animate__animated animate__fadeInDown",
        },
        hideClass: {
          popup: "animate__animated animate__fadeOutUp",
        },
      }).then(() => {
        // this.$router.back()
      });
    },
    alertSuksesPublishSio() {
      Swal.fire({
        title: "Proses Pengajuan CoC",
        text: "Dokumen CoC Lengkap, CoC dapat diproses !",
        icon: "success",
        showConfirmButton: false,
        timer: 2000,
        showClass: {
          popup: "animate__animated animate__fadeInDown",
        },
        hideClass: {
          popup: "animate__animated animate__fadeOutUp",
        },
      }).then(() => {
        // this.$refs.closeModalReject.click();
        this.$router.back();
      });
    },
    alertSuksesRejectSio(refform) {
      let namaform = this.listDokumen[refform - 1].label;

      Swal.fire({
        title: "Proses Review CoC",
        text: "Dokumen CoC : " + namaform + " Belum Lengkap!",
        icon: "success",
        showConfirmButton: false,
        timer: 2000,
        showClass: {
          popup: "animate__animated animate__fadeInDown",
        },
        hideClass: {
          popup: "animate__animated animate__fadeOutUp",
        },
      }).then(() => {
        if (refform == 1) {
          this.$refs.closeModalReject1.click();
        } else if (refform == 2) {
          this.$refs.closeModalReject2.click();
        } else if (refform == 3) {
          this.$refs.closeModalReject3.click();
        } else if (refform == 4) {
          this.$refs.closeModalReject4.click();
        } else if (refform == 5) {
          this.$refs.closeModalReject5.click();
        } else if (refform == 6) {
          this.$refs.closeModalReject6.click();
        } else if (refform == 7) {
          this.$refs.closeModalReject7.click();
        }

        this.$router.go();
      });
    },

    removeFile(idrefform, filename, idform) {
      this.isLoading = true;
      let url = null;
      let bodyJson = {};
      let methods = "post";
      if (idrefform == 3) {
        url = url_del_form3;
        bodyJson = {
          id: idform,
          idSio: this.sioID,
          attachmentFile: filename,
          attachmentDelete: true,
        };
      } else if (idrefform == 4) {
        url = url_del_form4;
        bodyJson = {
          id: idform,
          idSio: this.sioID,
          attachmentFile: filename,
          attachmentDelete: true,
        };
      } else if (idrefform == 5) {
        url = url_del_form5;
        bodyJson = {
          id: idform,
          idSio: this.sioID,
          attachmentFile: filename,
          attachmentDelete: true,
        };
      } else if (idrefform == 6) {
        url = url_del_form6;
        methods = "delete";
      } else if (idrefform == 7) {
        url = url_del_form7;
        bodyJson = {
          id: idform,
          idSio: this.sioID,
          attachment: filename,
          isDeleteAttachment: true,
        };
      }

      if (url != null) {
        if (methods == "post") {
          axios
            .post(url, bodyJson, {
              headers: {
                role: this.userData.role,
                Authorization: "Bearer " + this.userData.token,
                accept: "*/*",
              },
            })
            .then((response) => {
              console.log("response delete file : ", response);
              this.alertSuksesDeleteFile();

              this.isLoading = false;
              window.location.reload();
            })
            .catch((error) => {
              this.isLoading = false;
              console.log("error delete file : ", error);
              alert("error delete file");
            });
        } else if (methods == "delete") {
          axios
            .delete(url + idform, {
              headers: {
                role: this.userData.role,
                Authorization: "Bearer " + this.userData.token,
                accept: "*/*",
              },
            })
            .then((response) => {
              console.log("delete file : ", response);
              this.alertSuksesDeleteFile();
              this.isLoading = false;
            })
            .catch((error) => {
              this.isLoading = false;
              console.error(error);
              alert("error delete file");
            });
        }
      }
    },
    downloadFile(filename, label) {
      axios
        .get(url_download + filename, { responseType: "blob" })
        .then((response) => {
          this.handleFileDownload(response.data, filename, label);
        })
        .catch((error) => {
          console.error("Error downloading file:", error);
        });
    },
    handleFileDownload(blobData, filename, label) {
      var dateNow = moment(new Date()).format("DDMMYYYY");
      // Create a Blob from the response data
      const blob = new Blob([blobData], { type: "application/octet-stream" });
      // Create a link element and trigger a download
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = label + "_" + dateNow + ".pdf"; // Set the desired file name
      // link.target="_blank"
      link.click();
    },
    viewFile(fileName) {
      window.open(url_view_document + fileName, "_blank");
    },
    fetchDataKontraktor(id) {
      axios
        .get(url_detail_kontraktor + id)
        .then((response) => {
          console.log(response.data.detailKontraktor);
          this.kontraktorName = response.data.detailKontraktor.namaKontraktor;
        })
        .catch((error) => {
          alert("Error Fetch Data List Kontraktor : " + error.message);
          console.error("Error fetching data:", error);
        });
    },
    rejectSio(refform, idform) {
      let url_form_reason = "";
      let rsn = "";
      if (refform == 1) {
        url_form_reason = url_simpan_form1;
        rsn = this.reason_form1;
      } else if (refform == 2) {
        url_form_reason = url_simpan_form2;
        rsn = this.reason_form2;
      } else if (refform == 3) {
        url_form_reason = url_simpan_form3;
        rsn = this.reason_form3;
      } else if (refform == 4) {
        url_form_reason = url_simpan_form4;
        rsn = this.reason_form4;
      } else if (refform == 5) {
        url_form_reason = url_simpan_form5;
        rsn = this.reason_form5;
      } else if (refform == 6) {
        url_form_reason = url_set_sioid;
        rsn = this.reason_form6;
        this.reasondata.reasonDocument = rsn;
        if (rsn != "")
          this.reasondata.reasonDocumentDate = moment(new Date()).format(
            "YYYY-MM-DD HH:mm:ss"
          );
      } else if (refform == 7) {
        url_form_reason = url_set_sioid;
        rsn = this.reason_form7;
        this.reasondata.reasonImkp = rsn;
        if (rsn != "")
          this.reasondata.reasonImkpDate = moment(new Date()).format(
            "YYYY-MM-DD HH:mm:ss"
          );
      }
      if (rsn.trim() == "") {
        alert("Lengkapi pengisian form !");
        this.isLoading = false;
        return;
      }

      if (refform <= 2) {
        let bodyJson = {
          id: idform,
          reason: rsn,
        };
        axios
          .post(url_form_reason, bodyJson, {
            headers: {
              role: "isafe",
              Authorization: "Bearer " + this.userData.token,
              accept: "*/*",
            },
          })
          .then((response) => {
            console.log("response rejectSio : ", response);
            this.alertSuksesRejectSio(refform);
            this.status = 1;
            this.isLoading = false;
          })
          .catch((error) => {
            this.isLoading = false;
            console.log("error rejectSio : ", error);
            alert("error rejectSio");
          })
          .then(() => {});
      } else if (refform >= 3 && refform <= 5) {
        let bodyJson = {
          id: idform,
          attachmentDelete: true,
          reason: rsn,
        };
        axios
          .post(url_form_reason, bodyJson, {
            headers: {
              role: "isafe",
              Authorization: "Bearer " + this.userData.token,
              accept: "*/*",
            },
          })
          .then((response) => {
            console.log("response rejectSio : ", response);
            this.alertSuksesRejectSio(refform);
            this.status = 1;
            this.isLoading = false;
          })
          .catch((error) => {
            this.isLoading = false;
            console.log("error rejectSio : ", error);
            alert("error rejectSio");
          })
          .then(() => {});
      } else {
        let bodyJsonRD = {
          id: this.sioID,
          reasonData: JSON.stringify(this.reasondata),
          type: this.type,
        };
        axios
          .post(url_form_reason, bodyJsonRD, {
            headers: {
              role: "isafe",
              Authorization: "Bearer " + this.userData.token,
              accept: "*/*",
            },
          })
          .then((response) => {
            console.log("response rejectSio : ", response);
            this.alertSuksesRejectSio(refform);
            // this.status = 1;
            this.isLoading = false;
          })
          .catch((error) => {
            this.isLoading = false;
            console.log("error rejectSio : ", error);
            alert("error rejectSio");
          })
          .then(() => {});
      }
    },

    submitSio() {
      Swal.fire({
        title: "Apakah Anda yakin menyetujui pengajuan CoC ini ?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Ya",
      }).then((result) => {
        if (result.isConfirmed) {
          let bodyJson = {
            kontraktorId: this.kontraktorID,
            action: "approved",
            id: this.sioID,
            type: this.type,
          };
          axios
            .post(url_set_sioid, bodyJson, {
              headers: {
                role: "isafe",
                Authorization: "Bearer " + this.userData.token,
                accept: "application/json",
              },
            })
            .then((response) => {
              console.log("response submitSio : ", response);
              this.alertSuksesPublishSio();
              this.isLoading = false;
            })
            .catch((error) => {
              this.isLoading = false;
              console.log("error submitSio : ", error);
              util.showError(error.response.data.status.message)
            })
            .then(() => {});
        }
      });
    },
    lihatCatatan(note) {
      this.catatan = note;
    },
    redirectToLink(link, id) {
      window.open(link + id, "_blank");
    },
  },
};
</script>

<style scoped>
section {
  font-family: "Inter", sans-serif;
  font-style: normal;
  min-height: 100vh;
}

.btn_eform {
  background-color: #fff;
  border: #d0d5dd;
}
</style>
